<div class="dm-admin admin-shell">
  <header class="admin-topbar">
    <div class="admin-brand">
      <img src="assets/images/logos/logo_dm_light.svg" alt="DM Manufacturing" class="admin-logo"/>
      <span class="admin-tag">{{ 'admin.title' | translate }}</span>
    </div>

    <nav class="admin-nav" [attr.aria-label]="'admin.title' | translate">
      <a routerLink="documents" routerLinkActive="active">
        <i-tabler name="files" class="icon-18"></i-tabler>{{ 'admin.nav_documents' | translate }}
      </a>
      @if (canManageUsers) {
        <a routerLink="users" routerLinkActive="active">
          <i-tabler name="users" class="icon-18"></i-tabler>{{ 'admin.nav_users' | translate }}
        </a>
      }
      @if (isPlatformAdmin) {
        <a routerLink="companies" routerLinkActive="active">
          <i-tabler name="building" class="icon-18"></i-tabler>{{ 'admin.nav_companies' | translate }}
        </a>
      }
    </nav>

    <div class="admin-actions">
      <button type="button" class="dm-a-btn ghost" (click)="goToDocuments()">
        <i-tabler name="sparkles" class="icon-18"></i-tabler>
        <span class="hide-sm">{{ 'admin.go_assistant' | translate }}</span>
      </button>
      <button type="button" class="admin-avatar" [matMenuTriggerFor]="userMenu" [attr.aria-label]="'documents.account' | translate">
        {{ userInitials }}
      </button>
      <mat-menu #userMenu="matMenu">
        <div class="admin-user-info">
          <strong>{{ user?.name }} {{ user?.lastname }}</strong>
          <span>{{ user?.email }}</span>
        </div>
        <button mat-menu-item (click)="logout()">
          <i-tabler name="logout" class="icon-18 m-r-8"></i-tabler>
          {{ 'documents.logout' | translate }}
        </button>
      </mat-menu>
    </div>
  </header>

  <main class="admin-content">
    <router-outlet></router-outlet>
  </main>
</div>
